import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})

export class HomePageComponent implements AfterViewInit, OnInit {
  @ViewChild('videoLoopHome') videoLoopHome: ElementRef<HTMLVideoElement>;
  isDateInRange: boolean = false;

  ngOnInit(): void {
        // CYBERFIL 2024
        const today = new Date(); // Fecha actual
        const startDate = new Date('2024-11-01T00:00:00-03:00'); // Fecha de inicio
        const endDate = new Date(2024, 10, 15, 23, 59, 59, 999); // 15 de noviembre
    
        // Asegúrate de que las comparaciones se hagan en la misma zona horaria
        this.isDateInRange = today >= startDate && today <= endDate;
    
        // Para depurar
        console.log('Fecha hoy:', today);
        console.log('Fecha de inicio:', startDate);
        console.log('Fecha de fin:', endDate);
        console.log('¿Está en el rango?', this.isDateInRange);
        // END CYBERFIL 2024
  }

  ngAfterViewInit(): void {
    this.initializeVideoPlayback();
  }

  private initializeVideoPlayback() {
    const videoElement = this.videoLoopHome.nativeElement;
    
    // Verificar si el video puede reproducirse hasta el final sin pausar para cargar.
    const canPlayThrough = () => {
      videoElement.play().then(() => {
        console.log('Reproducción automática iniciada con éxito');
      }).catch(err => {
        console.error('Error al intentar la reproducción automática:', err);
        // Intenta silenciar y reproducir si la primera reproducción falla.
        videoElement.muted = true;
        videoElement.play().catch(err => console.error('Error al reproducir el video incluso después de silenciar:', err));
      });
    };

    // Verificar si el video está suficientemente cargado para reproducirse.
    if (videoElement.readyState >= 3) { // 3 = HAVE_FUTURE_DATA
      canPlayThrough();
    } else {
      videoElement.addEventListener('canplaythrough', canPlayThrough);
    }

    videoElement.addEventListener('error', () => {
      console.error('Error al cargar el video');
    });
  }
}
